export default __webpack_public_path__ + "static/media/twerk.c62503b2.png";